import { ChevronLeft, ChevronRight, Plus } from "lucide-react";
import { motion } from "motion/react";

export default function CapsPagination({
  page,
  totalPages,
  onPageChange,
  onLoadMore,
  canLoadMore,
}) {
  if (totalPages <= 1) return null;

  return (
    <motion.nav
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      aria-label="Caps pagination"
      className="mt-14 flex flex-col items-center gap-5"
    >
      <div className="flex items-center justify-center gap-2">
        <button
          type="button"
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
          className="flex size-11 items-center justify-center rounded-full border border-border transition hover:border-neutral-950 disabled:cursor-not-allowed disabled:opacity-35"
        >
          <ChevronLeft className="size-4" />
        </button>

        {Array.from({ length: totalPages }, (_, index) => index + 1).map(
          (pageNumber) => (
            <button
              key={pageNumber}
              type="button"
              onClick={() => onPageChange(pageNumber)}
              aria-label={`Go to page ${pageNumber}`}
              aria-current={pageNumber === page ? "page" : undefined}
              className={`flex size-11 items-center justify-center rounded-full text-sm font-black transition ${
                pageNumber === page
                  ? "bg-neutral-950 text-white"
                  : "border border-border bg-white hover:border-neutral-950"
              }`}
            >
              {pageNumber}
            </button>
          )
        )}

        <button
          type="button"
          disabled={page === totalPages}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
          className="flex size-11 items-center justify-center rounded-full border border-border transition hover:border-neutral-950 disabled:cursor-not-allowed disabled:opacity-35"
        >
          <ChevronRight className="size-4" />
        </button>
      </div>

      {canLoadMore && (
        <button
          type="button"
          onClick={onLoadMore}
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-full border border-neutral-950 bg-white px-7 py-3 text-sm font-black uppercase transition hover:bg-neutral-950 hover:text-white focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2"
        >
          <Plus className="size-4" />
          Load More
        </button>
      )}
    </motion.nav>
  );
}